import { BidsSortable } from "components/bids";
import { dateTimeToView } from "helpers/date";
import { featureModuleTypesEnum } from "helpers/enums";
import { tableContainer } from "helpers/redux";
import compact from "lodash/compact";
import React from "react";
import { showWorkRestInfo } from "sources/profile/organization";
import Filter from "./filter";
import List from "./list";

class SuitableDistributionBids extends BidsSortable {
    state = {
        items: [],
        filtersOpened: false,
        filtersLoaded: false,
        activeSort: {},
    };

    componentDidMount() {
        const planningCarScheduleEnabled = this.props.profile.availableFeatureModules.includes(
            featureModuleTypesEnum.PlanningCarSchedule,
        );
        if (planningCarScheduleEnabled) {
            showWorkRestInfo().then(({ matchingDistributionBidsRadius }) => {
                const { params } = this.props;
                params.customFilters = { emptyMileage: { le: matchingDistributionBidsRadius } };
                params.preparedFilter = { and: { emptyMileage: { le: matchingDistributionBidsRadius } } };
                setTimeout(() => {
                    this.setState({ filtersLoaded: true });
                }, 0);
            });
        } else {
            this.setState({ filtersLoaded: true });
        }
    }

    componentWillUnmount() {
        this.props.clearParams();
    }

    renderCreateButton = () => null;

    renderHead = () => {
        const { title, close, carInfo } = this.props;
        const { city, state, number, estimatedLeaveDate } = carInfo;
        const info =
            city || state || estimatedLeaveDate
                ? `(${compact([city, state, estimatedLeaveDate ? dateTimeToView(estimatedLeaveDate) : null]).join(".")})`
                : "";
        return (
            <div className="modal-window__header">
                <div className="modal-window__header-title">
                    {title}
                    &nbsp;
                    <small className="text-muted">{`для машины ${number} ${info}`}</small>
                </div>
                <div className="close close--sm" onClick={close} />
            </div>
        );
    };

    toggleFilter = () => {
        this.setState({ filtersOpened: !this.state.filtersOpened });
    };

    render() {
        const { params, mergeParams, organizationTimezone, organization, enums } = this.props;
        const { customFilters } = params;
        const { items, activeSort, filtersOpened } = this.state;
        const listProps = {
            activeSort,
            sortData: this.sortData,
            checkedItems: items,
        };

        const filterProps = {
            params,
            enums,
            mergeParams,
            organizationTimezone,
            filtersOpened,
            organization,
            filters: customFilters || {},
            toggleFilter: this.toggleFilter,
        };

        if (!this.state.filtersLoaded) {
            return null;
        }

        return (
            <div className="modal__window modal-window modal-window--wide">
                <div className="page-book__list book-list list">
                    {this.renderHead()}
                    <div className="mb-3">
                        <Filter {...filterProps} />
                    </div>
                    <List {...this.props} {...listProps} />
                </div>
            </div>
        );
    }
}

export default tableContainer(SuitableDistributionBids, "suitable-distribution-bids");
